import ToDoScheduleEventDetail from './ToDoScheduleEventDetail';

const ViewToDoScheduleEvent = () => <ToDoScheduleEventDetail mode="view" />;

export default ViewToDoScheduleEvent;
